import { Box, Table, TableRow, TopBar } from '@sam/components';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useData } from 'shared';
import { generateTableRowsForInventoryCategories } from '../../utils/inventory/Inventory.utils';
import { useTranslation } from 'react-i18next';
import { TableHeader } from '@sam/components/src/Table/Table.types';
import { IconComponent, IconType } from '../../components/icons/IconComponent';

export const InventoryCategoryOverview: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { data: loadedCategories } = useData('INVENTORY_CATEGORY_ALL', {
    config: { fallbackData: [] },
  });

  /**
   * TableRows displaying the avialable categories
   */
  const rows: TableRow[] = useMemo(
    () => generateTableRowsForInventoryCategories(loadedCategories, navigate),
    [loadedCategories, navigate],
  );

  return (
    <div>
      <TopBar
        title={t('pages.inventoryCategory.overview.topBarHeadline')}
        children={[
          <IconComponent
            type={IconType.ADD}
            className="clickable"
            onClick={() => navigate('edit')}
          />,
        ]}
      />
      <Box>
        <Table
          rows={rows}
          header={
            t('pages.inventoryCategory.overview.tableHeader', {
              returnObjects: true,
            }) as TableHeader[]
          }
        />
      </Box>
    </div>
  );
};
